import { Controller } from '@hotwired/stimulus';

// Prefetch des liens de la landing au toucher et au clavier.
//
// Turbo 8 préchauffe un lien quand la souris le survole (`mouseenter`, puis 100 ms) : la requête
// est alors déjà partie, ou terminée, quand le clic arrive. Au doigt ou au clavier il n'y a pas de
// survol, donc pas de prefetch. On déclenche le même geste au `touchstart` (le doigt est posé
// 60 à 150 ms avant le clic) et au `focusin` (navigation au clavier), en laissant Turbo décider
// ensuite : il ignore les liens qui ne sont pas éligibles (`data-turbo-prefetch="true"` requis,
// puisque l'app le coupe sur tout le document), les liens externes et les ancres de la page
// courante.
//
// Turbo ne garde qu'UNE réponse préchauffée à la fois : on suit donc l'intention d'un lien, pas
// la liste de tous ceux de la nav. Les précharger tous coûterait autant de rendus serveur par
// visite, ce que la landing, déjà chère à rendre, n'a pas à payer.
export default class extends Controller {
  connect() {
    this.warm = this.warm.bind(this);
    this.element.addEventListener('touchstart', this.warm, { passive: true });
    this.element.addEventListener('focusin', this.warm);
  }

  disconnect() {
    this.element.removeEventListener('touchstart', this.warm);
    this.element.removeEventListener('focusin', this.warm);
  }

  warm(event) {
    const link = event.target.closest?.('a[href]');
    if (!link) return;

    // Turbo écoute `mouseenter` en capture sur le document : un évènement synthétique, qui ne
    // remonte pas, lui parvient quand même.
    link.dispatchEvent(new MouseEvent('mouseenter'));
  }
}
